import React from 'react'
import { Check } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

const PricingSection = () => {
  const navigate = useNavigate()

  const handleStartTrial = () => {
    navigate('/signup')
  }

  const features = [
    "Full access to dashboard + 1 sensor device",
    "30-day risk-free trial",
    "Cancel anytime"
  ]

  return (
    <section id="pricing" className="section-padding bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl font-bold text-gray-900 mb-6">
          Simple pricing. No surprises.
        </h2>

        <div className="card-shadow p-8 mb-8 group hover:scale-105 transition-transform duration-200">
          <div className="text-5xl font-bold text-gray-900 mb-2">$99</div>
          <div className="text-lg text-gray-600 mb-6">per month</div>

          <div className="space-y-4 mb-6">
            {features.map((feature, index) => (
              <div key={index} className="flex items-center justify-center gap-3">
                <Check className="w-5 h-5 text-green-600 flex-shrink-0" />
                <span className="text-gray-700">{feature}</span>
              </div>
            ))}
          </div>

          <div className="text-sm text-gray-500 space-y-1 mb-6">
            <p>Additional locations or sensors billed separately.</p>
            <p>One sensor is enough for most small businesses.</p>
            <p>Typically covers most single-floor spaces.</p>
          </div>

          <div className="flex flex-col items-center">
            <button
              onClick={handleStartTrial}
              className="btn-primary w-full sm:w-auto"
            >
              30-Day Risk-Free Trial
            </button>
            <span className="text-sm text-gray-500 mt-2">
              Hardware ships after signup. Trial converts to $99/month unless canceled.
            </span>
          </div>
        </div>

        <p className="text-gray-600 text-lg leading-relaxed">
          Enterprise camera systems cost $50,000+ a year. Our solution delivers the insights you need —
          for less than one dinner out each month. And instead of guessing, you'll finally understand
          both customer and potential customer traffic.
        </p>
      </div>
    </section>
  )
}

export default PricingSection
